export const draftColors = {
  pageBg: "#F8FAFC",
  surface: "#FFFFFF",
  surfaceMuted: "#F9FAFC",
  surfaceTableHeader: "#F2F5F9",
  chipBg: "#EEF2FE",
  chipText: "#253A84",
  textPrimary: "#212936",
  textSecondary: "#7B809A",
  textLabel: "#474A5A",
  textAction: "#344767",
  borderSoft: "#F0F2F5",
  border: "#E2E8F0",
  borderInput: "#D1D5DB",
  blue: "#1A73E7",
  green: "#4CAF50",
  red: "#F44334",
  shadow: "0px 2px 6px 0px rgba(151, 172, 198, 0.25)",
} as const;

export const draftTypography = {
  title: { fontSize: "16px", fontWeight: 900, lineHeight: "1.399999976158142em" },
  body14: { fontSize: "14px", fontWeight: 600, lineHeight: "1.4000000272478377em" },
  body14Bold: { fontSize: "14px", fontWeight: 900, lineHeight: "1.4000000272478377em" },
  body12: { fontSize: "12px", fontWeight: 400, lineHeight: "1.3999999364217122em" },
  label12Bold: { fontSize: "12px", fontWeight: 700, lineHeight: "1.3999999364217122em" },
  label12Semi: { fontSize: "12px", fontWeight: 600, lineHeight: "1.3999999364217122em" },
  label11: {
    fontSize: "11px",
    fontWeight: 400,
    lineHeight: "1.3999999653209338em",
    letterSpacing: "0.05em",
  },
  label9: {
    fontSize: "9px",
    fontWeight: 400,
    lineHeight: "1.3999999364217122em",
    letterSpacing: "0.05em",
  },
} as const;
